import type { ProfileCurrenciesResponseState } from '@/socket/profile/dto/index';

export const useRegularSocket = () => {
    /**
     * 收听最新的汇率信息 
     * 另有一个 profile.getCurrencies 可用于主动查询汇率 
     * @param callback 
     */
    const ON_UPDATE_RATES = (
        callback: (data: ProfileCurrenciesResponseState) => any,
    ) => {
        socket.on(`updateRates`, callback);
    };

    return { ON_UPDATE_RATES };
};

